export default "__VITE_ASSET__DYinsHp___"